import { Controller } from "@hotwired/stimulus"

// Navigates to the current page with a query param updated/removed based on the select's value.
export default class extends Controller {
  static values = { param: String }

  change(event) {
    const params = new URLSearchParams(window.location.search)
    const value = event.target.value

    if (value) {
      params.set(this.paramValue, value)
    } else {
      params.delete(this.paramValue)
    }

    window.location.search = params.toString()
  }
}
